namespace TabAurous.OMS {
    export interface AccountGroupRow {
        AccountGroupId?: number;
        AccountGroupName?: string;
        GroupUnder?: number;
        Narration?: string;
        IsDefault?: boolean;
        Nature?: string;
        AffectGrossProfit?: boolean;
        Balance?: number;
        Quarter1?: number;
        Quarter2?: number;
        Quarter3?: number;
        Quarter4?: number;
        Flow?: string;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        SysDate?: string;
    }

    export namespace AccountGroupRow {
        export const idProperty = 'AccountGroupId';
        export const nameProperty = 'AccountGroupName';
        export const localTextPrefix = 'OMS.AccountGroup';
        export const deletePermission = 'Masters:AccountGroup:Delete';
        export const insertPermission = 'Masters:AccountGroup:Add';
        export const readPermission = '*';
        export const updatePermission = 'Masters:AccountGroup:Edit';

        export declare const enum Fields {
            AccountGroupId = "AccountGroupId",
            AccountGroupName = "AccountGroupName",
            GroupUnder = "GroupUnder",
            Narration = "Narration",
            IsDefault = "IsDefault",
            Nature = "Nature",
            AffectGrossProfit = "AffectGrossProfit",
            Balance = "Balance",
            Quarter1 = "Quarter1",
            Quarter2 = "Quarter2",
            Quarter3 = "Quarter3",
            Quarter4 = "Quarter4",
            Flow = "Flow",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            SysDate = "SysDate"
        }
    }
}
